import React, { useEffect, useState } from 'react';

interface DisplayAdProps {
  className?: string;
}

export const DisplayAd: React.FC<DisplayAdProps> = ({ className = '' }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Defer AdSense loading until after page load for better performance
    const loadAdSense = () => {
      if (!window.adsbygoogle) {
        const script = document.createElement('script');
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9957943271015513';
        script.crossOrigin = 'anonymous';
        script.async = true;
        script.onload = () => setIsLoaded(true);
        document.head.appendChild(script);
      } else {
        setIsLoaded(true);
      }

      // Push the ad after script loads
      if (window.adsbygoogle && isLoaded) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    };

    // Use requestIdleCallback or setTimeout for better performance
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadAdSense);
    } else {
      setTimeout(loadAdSense, 100);
    }
  }, [isLoaded]);

  return (
    <div className={`my-8 ${className}`}>
      <ins 
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-9957943271015513"
        data-ad-slot="4122071584"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}; 